// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1Cqu_","card":"Cards_card__3fHq7","infected":"Cards_infected__3UaWr","recovered":"Cards_recovered__3BzkZ","deaths":"Cards_deaths__3QrsU"};